<div id="login-form">
  <div *ngIf="invalidToken">
    <div *ngIf="invalidToken" class="alert alert-danger" style="font-size: 13px;">The token has been already used or
      expired. Please request a new reset password link
    </div>
    <div class="login-form-actions text-center">
      <div class="login-form-actions text-center">
        <div>
          <p-button (click)="setAuthenticationServiceIsLoading(true)" label="cancel" routerLink="/"
                    styleClass="btn btn-primary btn-sm text-right"></p-button>
        </div>
      </div>
    </div>
  </div>
  <form *ngIf="!invalidToken" [formGroup]="passwordForm" class="form-horizontal">
    <div *ngIf="error">
      <div class="alert alert-danger" style="font-size: 13px;">An error occurred while processing your request.</div>
    </div>
    <div *ngIf="passwordNotSecure">
      <div class="alert alert-danger" style="font-size: 13px;">Your new password doesn't meet the requirements below.</div>
    </div>
    <div [ngClass]="{'has-error': showErrorMessage('newPassword')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="newPassword">New Password</label>
      <div class="col-8 col-form-input">
        <input formControlName="newPassword" id="newPassword" pInputText type="password"/>
      </div>
    </div>
    <div [ngClass]="{'has-error': showErrorMessage('newPassword')}" class="p-grid form-group">
      <label class="col-4 col-form-label text-right" for="confirmNewPassword">Confirm new password</label>
      <div class="col-8 col-form-input">
        <input formControlName="confirmNewPassword" id="confirmNewPassword" pInputText type="password"/>
      </div>
    </div>
    <app-password-strength (passwordStrength)="passwordValid($event)"
                           [confirmPasswordToCheck]="passwordForm.value.confirmNewPassword"
                           [passwordToCheck]="passwordForm.value.newPassword"></app-password-strength>
    <div class="login-form-actions text-center">
      <div>
        <p-button [disabled]="!passwordIsValid" label="Submit" type="submit" styleClass="btn btn-primary btn-sm text-right" (click)="onSubmit()"></p-button>
        &nbsp; &nbsp; <a (click)="setAuthenticationServiceIsLoading(true)" routerLink="/"><i
        class="fa fa-backward alert-dark"></i> Cancel </a>
      </div>
    </div>
  </form>
</div>
